import { render, staticRenderFns } from "./MoleRatio.vue?vue&type=template&id=5163d59b&"
import script from "./MoleRatio.vue?vue&type=script&lang=js&"
export * from "./MoleRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports